import { render, staticRenderFns } from "./InspectRecordsInfo.vue?vue&type=template&id=6ad440d4&scoped=true"
import script from "./InspectRecordsInfo.vue?vue&type=script&lang=js"
export * from "./InspectRecordsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad440d4",
  null
  
)

export default component.exports